import api from '@/libs/api'
import uploadS3 from '@/libs/uploadS3'
import Helpers, { getContactNumber } from '@/libs/helpers'
import _get from 'lodash/get'
import { ONLINE, PAUSED, DIALING, ONTHEPHONE, RINGING } from '@/constants/agentStatuses'
import { CONNECTED, DISCARDED, COMPLETED, HOLD } from '@/constants/callStatus'
import { VOICE_CHANNEL, TEXT_CHANNEL, MAIL_CHANNEL } from '@/constants/channels'
import { v5 as uuidv5 } from 'uuid'
import { parse } from 'node-html-parser'
import moment from 'moment-timezone'
import { getRecorder } from '@/store/modules/sipModule'
import { getFormatedNumber } from '@/libs/startAttendance'
import { parseContactInfo, contactDisplayName } from '@/libs/contactInfo'
import { isLid } from '@/components/utils/phones'
import { pollButtonExecution } from '@/libs/buttonExecution'
import { countsForSchedulePause } from '@/libs/systemPause'
import { mergeAgentNotes, toAgentNotes } from '@/libs/agentNotes'

import {
  ROUTE_AUTH,
  ROUTE_ATTENDANCE_NEW,
  ROUTE_ATTENDANCE_ITEM,
  ROUTE_PREVIEW_CURRENT,
  ROUTE_PREVIEW_DETAILS
} from '@/router/constants'

let router = document.router
const shell = window.shell
const ipcRenderer = window.ipcRenderer
const recordings = {}
let textSyncState = null
const losedGraceTimers = new Map()

const MAX_RETRIES = 2
const RETRY_DELAY = 5000
const LOSED_SYNC_GRACE_MS = 5000
const uuidDNS = '34789426-0259-11eb-adc1-0242ac120002'
const SET_PROFILER_LOADED = 'SET_PROFILER_LOADED'
const SET_PROFILER_ANSWERS = 'SET_PROFILER_ANSWERS'
const SET_PROFILER_LOADING = 'SET_PROFILER_LOADING'
const SET_PROFILER_EMPTY = 'SET_PROFILER_EMPTY'
const SET_NO_PROFILER = 'SET_NO_PROFILER'
const SET_PROFILER_SUCCESS = 'SET_PROFILER_SUCCESS'
const SET_BUTTON_RESULT = 'SET_BUTTON_RESULT'
const SET_HISTORY_TO_ATTENDANCE = 'SET_HISTORY_TO_ATTENDANCE'

const START_ATTENDANCE_MAIL = 'START_ATTENDANCE_MAIL'
const SET_EMAIL_ATTENDANCE = 'SET_EMAIL_ATTENDANCE'
const ONGOING_EMAIL_ATTENDANCE = 'ONGOING_EMAIL_ATTENDANCE'

const LOAD_MAIL_MESSAGES_START = 'LOAD_MAIL_MESSAGES_START'
const LOAD_MAIL_MESSAGES_SUCCESS = 'LOAD_MAIL_MESSAGES_SUCCESS'
const LOAD_MAIL_MESSAGES_ERROR = 'LOAD_MAIL_MESSAGES_ERROR'

// const LOAD_MAIL_BODY_START = 'LOAD_MAIL_BODY_START'
const LOAD_MAIL_BODY_SUCCESS = 'LOAD_MAIL_BODY_SUCCESS'
// const LOAD_MAIL_BODY_ERROR = 'LOAD_MAIL_BODY_ERROR'

const SENDING_EMAIL_ATTENDANCE = 'SENDING_EMAIL_ATTENDANCE'
const NOT_SENDED_EMAIL_ATTENDANCE = 'NOT_SENDED_EMAIL_ATTENDANCE'
const ADD_ATTENDANCE_VOICE = 'ADD_ATTENDANCE_VOICE'
const UPDATE_ATTENDANCE = 'UPDATE_ATTENDANCE'
const UPDATE_ATTENDANCE_HISTORY = 'UPDATE_ATTENDANCE_HISTORY'
const FINISH_SEND_MAIL = 'FINISH_SEND_MAIL'
const SET_HISTORY_KNOW = 'SET_HISTORY_KNOW'
const GIVEUP_MAIL = 'GIVEUP_MAIL'
const UPDATE_CONTACT = 'UPDATE_CONTACT'

const UPDATE_ATTENDANCE_VOICE = 'UPDATE_ATTENDANCE_VOICE'
const FINISH_ATTENDANCE_VOICE = 'FINISH_ATTENDANCE_VOICE'
const CLEAR_INITIAL_HISTORY = 'CLEAR_INITIAL_HISTORY'
const SET_ATTENDANCE_HISTORY = 'SET_ATTENDANCE_HISTORY'
const SET_CALL = 'SET_CALL'
const DISCARD_CONFERENCE = 'DISCARD_CONFERENCE'
const ADD_ATTENDANCE_CONFERENCE = 'ADD_ATTENDANCE_CONFERENCE'
const SET_AGENT_TEXT = 'SET_AGENT_TEXT'
const SET_TEXT_MESSAGE = 'SET_TEXT_MESSAGE'
const SET_ATTENDANCE_TEXT_MESSAGE = 'SET_ATTENDANCE_TEXT_MESSAGE'
const SET_ATTENDANCES_TEXT_MESSAGE = 'SET_ATTENDANCES_TEXT_MESSAGE'
const ADD_ATTENDANCES_TEXT_MESSAGE = 'ADD_ATTENDANCES_TEXT_MESSAGE'
const DROP_ATTENDANCE_TEXT_MESSAGE = 'DROP_ATTENDANCE_TEXT_MESSAGE'
const DROP_SKETCH_TEXT_MESSAGE = 'DROP_SKETCH_TEXT_MESSAGE'
const CLEAR_ATTENDANCES_TEXT_MESSAGE = 'CLEAR_ATTENDANCES_TEXT_MESSAGE'
const FINISHING_ATTENDANCE_TEXT = 'FINISHING_ATTENDANCE_TEXT'
const FINISH_ATTENDANCE_TEXT = 'FINISH_ATTENDANCE_TEXT'
const SET_FREQUENCY = 'SET_FREQUENCY'
const SET_INPUT_ROWS_TEXT_MESSAGE = 'SET_INPUT_ROWS_TEXT_MESSAGE'
const LOSED_ATTENDANCES_TEXT_MESSAGE = 'LOSED_ATTENDANCES_TEXT_MESSAGE'

const SET_READED = 'SET_READED'
const SET_CHAT_MANUAL_UNREAD = 'SET_CHAT_MANUAL_UNREAD'
const SET_ATTENDANCE_ATTACHMENT = 'SET_ATTENDANCE_ATTACHMENT'
const REMOVE_ATTENDANCE_ATTACHMENT = 'REMOVE_ATTENDANCE_ATTACHMENT'
const UPDATE_OPTION_CALLBACK = 'UPDATE_OPTION_CALLBACK'
const RESET_OPTION_CALLBACK = 'RESET_OPTION_CALLBACK'

const ADD_ATTENDANCE_TO_PREVIEW_SET = 'ADD_ATTENDANCE_TO_PREVIEW_SET'
const SET_PREVIEW_QUEUE_ID = 'SET_PREVIEW_QUEUE_ID'
const REMOVE_ATTENDANCE_FROM_PREVIEW = 'REMOVE_ATTENDANCE_FROM_PREVIEW'
const ADD_CONTACT_TO_PREVIEW = 'ADD_CONTACT_TO_PREVIEW'
const REMOVE_CONTACT_FROM_PREVIEW = 'REMOVE_CONTACT_FROM_PREVIEW'
const SET_PREVIEW_STATUS = 'SET_PREVIEW_STATUS'
const SET_PREVIEW_PROFILER = 'SET_PREVIEW_PROFILER'
const SET_PREVIEW_CONTACT_STATUS = 'SET_PREVIEW_CONTACT_STATUS'
const SET_PREVIEW_PHONE_STATUS = 'SET_PREVIEW_PHONE_STATUS'

const onStopRecording = async (state, attendanceId) => {
  const rec = recordings[attendanceId]
  if (!rec || !rec.recorder) return

  try {
    const mp3Blob = await rec.recorder.stop()
    if (!mp3Blob) return
    let callOngoing = true
    let attendance = { ...state.current[attendanceId] }

    if (!attendance.id) {
      attendance = { ...state.history[attendanceId] }
      callOngoing = false
    }

    const updatedAttendance = {
      ...attendance,
      isRecording: false,
      startRecordTimestamp: null,
      recordBlob: mp3Blob,
      recordUrl: window.URL.createObjectURL(mp3Blob)
    }
    recordings[attendanceId] = null

    if (callOngoing) {
      state.current[attendanceId] = updatedAttendance
      return
    }

    state.history[attendanceId] = updatedAttendance
  } catch (error) {
    console.error('Erro ao parar gravação:', error)
  }
}

const getAttendanceNumber = (attendance, areaCode) => {
  if (attendance.originalCallerNumber) return attendance.originalCallerNumber
  const callIdNum = attendance.contact.replace(/\s+/g, '').replace(/^0+/, '')
  const fullNumber = callIdNum.length <= 9 ? `${areaCode}${callIdNum}` : callIdNum
  return fullNumber
}

const isFinalStatus = (status) => (status === 'FINISHED' || status === 'ONSURVEY')
const extractChatStatus = (response) => response?.chat?.status
const normalizeId = (id) => id?.toString()

const scheduleLosedGrace = (ctx, attendanceId) => {
  if (losedGraceTimers.has(attendanceId)) return

  losedGraceTimers.set(attendanceId, setTimeout(() => {
    losedGraceTimers.delete(attendanceId)
    if (ctx.state.current[attendanceId]) ctx.commit(LOSED_ATTENDANCES_TEXT_MESSAGE, [attendanceId])
  }, LOSED_SYNC_GRACE_MS))
}

const cancelLosedGrace = (chatId) => {
  const attendanceId = normalizeId(chatId)
  if (!losedGraceTimers.has(attendanceId)) return

  clearTimeout(losedGraceTimers.get(attendanceId))
  losedGraceTimers.delete(attendanceId)
}

const buttonResultKey = ({ attendanceId, profilerId, hookId }) => `${attendanceId}:${profilerId}:${hookId}`

const clearButtonResults = (state, attendanceId) => {
  state.buttonResults = Object.fromEntries(
    Object.entries(state.buttonResults).filter(([key]) => !key.startsWith(`${attendanceId}:`))
  )
}

export const buildButtonPayload = ({ state, rootState }, { attendanceId, profilerId }) => {
  const attendance = state.current[attendanceId] || state.history[attendanceId]
  if (!attendance) throw new Error('attendance not found')

  const profiler = findProfilerById(state, attendanceId, profilerId)
  if (!profiler) throw new Error('profiler not found')

  const ura = attendance.sipHeaders || {}
  const { queue, direction, createdAt: created, queueId, callId, channel } = attendance
  const { agent: { id: agent, loginExtension: extension, name: agentName } } = rootState.agentModule.session
  const { mailing, fields, tree, contact } = profiler
  const profilerFields = (fields || []).map(({ id, type, answer }) => ({ id, type, answer })).filter(noButtonType)

  const body = { direction, agent, created, contact, agentName, channel, profiler: { fields: profilerFields, tree } }
  if (channel === 'VOICE') body.callId = callId || attendanceId
  if (channel !== 'VOICE') {
    body.chatId = attendanceId
    body.contact = attendance.sourceId
  }

  body.queue = queue || queueId
  body.contactId = ura['X-Dialer-Contact-Id']
  body.contactName = ura['X-Dialer-Contact-Name']

  return Object.assign(body, { ura, mailing, extension, flowVariables: attendance.flowVariables })
}

const execButtonRequest = async ({ state, rootState }, { attendanceId, profilerId, hookId }) => {
  const payload = buildButtonPayload({ state, rootState }, { attendanceId, profilerId })
  const result = await pollButtonExecution({
    start: () => api.startButtonExecution(profilerId, hookId, payload),
    fetch: (executionId) => api.getButtonExecution(profilerId, hookId, executionId)
  })
  return {
    display: Array.isArray(result?.display) ? result.display : [],
    executedAt: result?.executedAt || Date.now()
  }
}

export default {
  namespaced: true,

  state: {
    current: {},
    currentMessageId: {},
    history: {},
    callDetails: {},
    profilers: {},
    profilersEmail: {},
    buttonResults: {},
    conference: [],
    loading: false,
    chatInputRows: {},
    timerId: null,
    apiAttendanceData: null,
    optionCallback: {
      timer: 0,
      show: false,
      queue: null,
      contact: null,
      parentCallId: null,
      callbackCallId: null,
      callTransferred: false
    },
    preview: {
      attendances: new Set(),
      queueId: null,
      contact: {},
      loading: false,
      status: 'WAITING'
    }

  },

  getters: {
    apiAttendanceData: (state) => state.apiAttendanceData,
    inAttendance: (state) => Object.values(state.current).filter((attendance) => attendance?.id ?? attendance?.temporaryId).length,
    getAttendances: (state) => Object.values(state.current),
    getAttendance: (state) => (id) => state.current[id],
    getConference: (state) => state.conference,
    isLoading: (state) => state.loading,
    getChatInputRows: (state) => state.chatInputRows,
    currentMessageId: (state) => state.currentMessageId,
    optionCallback: (state) => state.optionCallback,
    ongoingCallInPreview: (state) => (id) => {
      const attendanceInPreview = state.preview.attendances.values().next().value
      if (!attendanceInPreview) return null

      const DIALING = state.preview.status === 'DIALING'
      if (DIALING) return attendanceInPreview
    },
    previewQueue: (state) => state.preview.queueId,
    previewStatus: (state) => state.preview.status,
    previewContacts: (state) => state.preview.contact,
    hasPerfilated: (state) => (id) => state.preview.contact[id]?.hasPerfilated
  },

  actions: {
    async startRecord (ctx, attendanceId) {
      try {
        const { recorder, micStream } = await getRecorder(attendanceId)
        if (!recorder) {
          console.error('Não foi possível inicializar o gravador')
          return
        }

        const now = Date.now()
        recordings[attendanceId] = { recorder, micStream, startRecordTime: now }

        recorder.start()
        ctx.commit('START_RECORDING', attendanceId)
      } catch (error) {
        console.error('Erro ao iniciar gravação:', error)
      }
    },

    async uploadRecordingToS3 ({ state, rootState, commit }, attendanceId) {
      const attendance = state.current[attendanceId] || state.history[attendanceId]
      if (!attendance || !attendance.recordBlob) return null
      const isAdmin = rootState.settingsModule.provision?.profile === 'ADMIN'

      const callId = attendance.callId || attendanceId
      let areaCode = rootState.settingsModule?.provision?.areaCode
      if (!areaCode) areaCode = rootState.agentModule?.provision?.areaCode || ''
      const callerIdNumber = getAttendanceNumber(attendance, areaCode)
      const hour = moment(attendance.createdAt).format('YYYYMMDD_HHmmss')
      const callIdFileName = isAdmin && /^ramal-\d+/.test(callId)
        ? callId.split('-').slice(0, 2).join('-')
        : callId
      const fileName = (isAdmin ? `admin/${hour}_` : '').concat(`${callIdFileName}_${callerIdNumber}.mp3`)
      const file = new File([attendance.recordBlob], fileName, { type: 'audio/mpeg' })

      const s3Result = await uploadS3(file, isAdmin, 'recording')

      if (isAdmin) {
        commit(UPDATE_ATTENDANCE, {
          id: attendanceId,
          recordUrl: s3Result.url,
          recordS3Url: s3Result.url,
          recordBlob: null
        })
      }

      return s3Result
    },

    async fetchRecordingS3Url ({ commit, state, rootState }, { attendanceId }) {
      if (!attendanceId) return null
      const isAdmin = rootState.settingsModule.provision?.profile === 'ADMIN'

      const canUseRecording = isAdmin
        ? rootState?.settingsModule?.provision?.canUseRecording === 'yes'
        : rootState.agentModule?.session?.configs?.canUseRecording === 'yes'
      if (!canUseRecording) return null

      const attendance = state.current[attendanceId] || state.history[attendanceId]
      if (!attendance || attendance.fetchingS3Url || attendance.status === 'DISCARDED') return null

      const areaCode = rootState.settingsModule?.provision?.areaCode || ''
      const callId = attendance.callId || attendanceId
      const callerIdNumber = getAttendanceNumber(attendance, areaCode)
      const fileName = `${callId}_${callerIdNumber}.mp3`

      const updateAttendance = (data) => commit(UPDATE_ATTENDANCE, { id: attendanceId, ...data })
      updateAttendance({ fetchingS3Url: true })

      let s3Url = null

      try {
        s3Url = await Helpers.retry(
          () => api.getRecordingS3Url(callId, fileName),
          1,
          2000
        )
      } catch (error) {
      } finally {
        updateAttendance({
          recordS3Url: s3Url,
          fetchingS3Url: false,
          recordS3UrlFetched: true
        })
      }

      return s3Url
    },

    toggleMicMute (ctx, { attendanceId, isMuted }) {
      const recording = recordings[Number(attendanceId)]
      if (recording && recordings[attendanceId].micStream) {
        const micTrack = recording.micStream.getAudioTracks()[0]
        if (micTrack) micTrack.enabled = !isMuted
      }
    },

    async stopRecord (ctx, attendanceId) {
      const recording = recordings[attendanceId]
      if (recording?.recorder) ctx.commit('STOP_RECORDING', attendanceId)
    },

    pauseRecord (ctx, attendanceId) {
      recordings[attendanceId]?.recorder?.pause()
    },

    resumeRecord (ctx, attendanceId) {
      recordings[attendanceId]?.recorder?.resume()
    },

    setReaded (ctx, args) {
      ctx.commit(SET_READED, args)
    },

    markChatAsUnread (ctx, chatId) {
      ctx.commit(SET_CHAT_MANUAL_UNREAD, { chatId, value: true })
    },

    clearChatUnreadMark (ctx, chatId) {
      ctx.commit(SET_CHAT_MANUAL_UNREAD, { chatId, value: false })
    },

    startUpload (ctx, { attendanceId, files }) {
      for (const file of files) {
        const { name, size, type: mime } = file
        const id = `${Date.now()}-${files.indexOf(file)}`
        const attachment = { id, name, size, mime, progress: 0, uploading: true }
        const isPublic = true
        ctx.commit(SET_ATTENDANCE_ATTACHMENT, { attendanceId, attachment })

        uploadS3(file, isPublic, 'upload', (progress) => {
          attachment.progress = Number((progress * 100).toFixed(1))
          ctx.commit(SET_ATTENDANCE_ATTACHMENT, { attendanceId, attachment })
        }).then(({ url }) => {
          attachment.url = url
          delete attachment.progress
          delete attachment.uploading
          ctx.commit(SET_ATTENDANCE_ATTACHMENT, { attendanceId, attachment })
        }).catch((err) => {
          console.log({ err })
          ctx.commit(REMOVE_ATTENDANCE_ATTACHMENT, { attendanceId, attachment })
        })
      }
    },

    async finishingAttendanceText (ctx, payload) {
      const state = ctx.state

      const clearTimer = () => {
        if (state.timerId) {
          clearTimeout(state.timerId)
          state.timerId = null
        }
      }

      const resetState = () => {
        ctx.commit(FINISHING_ATTENDANCE_TEXT, false)
        clearTimer()
      }

      const showErrorAlert = () => {
        alert(
          'ERRO: Não foi possível finalizar o atendimento.\n\n' +
          'Sua conexão pode estar sofrendo alguma instabilidade.\n\n' +
          'Tente novamente mais tarde.'
        )
      }

      const findChatAttendance = (chatId) => {
        const attendances = ctx.rootGetters['attendanceModule/getAttendances']
        return attendances.find(x => normalizeId(x.id) === normalizeId(chatId))
      }

      const checkChatStatus = async (chatId) => {
        try {
          const response = await api.getChatInfo(chatId)
          const status = extractChatStatus(response)

          if (!isFinalStatus(status)) return { finished: false }

          return { finished: true }
        } catch (error) {
          console.error('checkChatStatus error:', error)
          return { finished: false }
        }
      }

      const scheduleStatusCheck = (chatId, retryCount) => {
        const timerId = setTimeout(async () => {
          if (state.timerId !== timerId) return

          const result = await checkChatStatus(chatId)

          if (result.finished) {
            const attendance = findChatAttendance(chatId)

            if (attendance) {
              ctx.dispatch(
                'attendanceModule/finishAttendanceText',
                attendance,
                { root: true }
              )
            }

            resetState()
            return
          }

          if (retryCount < MAX_RETRIES) {
            ctx.dispatch(
              'socketModule/setFinished',
              { chatId, retryCount: retryCount + 1 },
              { root: true }
            )
            return
          }

          resetState()
          showErrorAlert()
        }, RETRY_DELAY)

        state.timerId = timerId
      }

      if (!payload) {
        resetState()
        return
      }

      const { chatId, retryCount = 0 } = payload

      clearTimer()
      ctx.commit(FINISHING_ATTENDANCE_TEXT, true)

      scheduleStatusCheck(chatId, retryCount)
    },

    async loadFrequency ({ state, commit }, attendanceId) {
      let attendance = null
      if (!attendance && state.current[attendanceId]) attendance = state.current[attendanceId]
      if (!attendance && state.history[attendanceId]) attendance = state.history[attendanceId]
      if (!attendance) return
      if (attendance.frequency) return
      if (attendance.direction !== 'IN') return

      const number = getContactNumber(attendance) || attendance.contact || attendanceId
      const frequency = await api.loadAttendanceFrequency(number, { createdAt: attendance?.createdAt }).catch(() => null)
      commit(SET_FREQUENCY, { attendanceId, frequency })
    },

    finishAttendanceText (ctx, attendance) {
      ctx.commit(FINISH_ATTENDANCE_TEXT, attendance)
    },

    async loadHistory (ctx, attendance) {
      if (!attendance) return []

      const { agentModule } = ctx.rootState
      const agent = agentModule.session?.agent
      const queues = agent?.membership.map(({ queueId }) => queueId)

      const contact = toContact(getContactNumber(attendance) ?? attendance.contact ?? attendance.subject)
      const response = await api.loadAttendanceHistory(attendance.page, contact, queues)
      const id = attendance.callId ?? attendance.id
      ctx.commit(SET_HISTORY_TO_ATTENDANCE, { attendanceId: id, response })
    },

    async loadCall ({ state, commit }, { callId, params }) {
      if (state.callDetails[callId]) {
        return state.callDetails[callId]
      }
      const call = await api.loadCall(callId, params)
      commit(SET_CALL, { callId, call })
      return call
    },

    async loadMessagesChat (ctx, { id: chatId }) {
      let chat = null
      if (!chat && ctx.state.current[chatId]) chat = { ...ctx.state.current[chatId] }
      if (!chat && ctx.state.history[chatId]) chat = { ...ctx.state.history[chatId] }
      if (!chat) return

      const params = { page: 1, limit: 33 }
      if (chat.messages?.length) {
        params.latestId = chat.messages.reduce((min, { id }) => Math.min(min, id), chat.messages[0].id)
      } else {
        params.byChatId = true
      }

      const { messages, notes, count } = await api.loadChatMessages(chat.id, params)

      ctx.commit(SET_ATTENDANCE_TEXT_MESSAGE, {
        id: chat.id,
        loadedAsEmpty: false,
        messages: toMessages(messages ?? []),
        notes: toAgentNotes(notes),
        hasMore: count > 0
      })
    },

    async setTextAttendance (ctx, chat) {
      ctx.commit(SET_ATTENDANCE_TEXT_MESSAGE, chatToAttendance(chat))
    },

    setTextAttendances (ctx, chats) {
      ctx.commit(SET_ATTENDANCES_TEXT_MESSAGE, chats)
    },

    addTextAttendances (ctx, chats) {
      ctx.commit(ADD_ATTENDANCES_TEXT_MESSAGE, chats)
    },

    clearTextAttendances (ctx, chats) {
      ctx.commit(CLEAR_ATTENDANCES_TEXT_MESSAGE, chats)
    },

    startSync (ctx) {
      const pendingTextIds = Object.values(ctx.state.current)
        .filter(({ channel, status }) => channel === TEXT_CHANNEL && status !== 'OFFERING')
        .map(({ id, temporaryId }) => normalizeId(id ?? temporaryId))
        .filter(Boolean)

      textSyncState = {
        pendingTextIds: new Set(pendingTextIds),
        syncedTextIds: new Set()
      }
    },

    onSyncComplete (ctx) {
      if (!textSyncState) return

      const staleAttendanceIds = []
      for (const attendanceId of textSyncState.pendingTextIds) {
        const attendance = ctx.state.current[attendanceId]
        const wasNotSynced = !textSyncState.syncedTextIds.has(attendanceId)

        if (attendance?.channel === TEXT_CHANNEL && wasNotSynced) {
          staleAttendanceIds.push(attendanceId)
        }
      }

      textSyncState = null

      staleAttendanceIds.forEach((attendanceId) => scheduleLosedGrace(ctx, attendanceId))
    },

    dropTextAttendance (ctx, attendanceId) {
      ctx.commit(DROP_ATTENDANCE_TEXT_MESSAGE, attendanceId)
    },

    dropSketchTextMessage (ctx, attendanceId) {
      ctx.commit(DROP_SKETCH_TEXT_MESSAGE, attendanceId)
    },

    setAgentText (ctx, event) {
      ctx.commit(SET_AGENT_TEXT, event)
    },

    setTextMessage (ctx, event) {
      ctx.commit(SET_TEXT_MESSAGE, event)
    },

    addAttendanceVoice (ctx, attendance) {
      ctx.commit(ADD_ATTENDANCE_VOICE, attendance)
    },

    startMail (ctx, attendance) {
      ctx.commit(START_ATTENDANCE_MAIL, attendance)
    },

    setMailAttendance (ctx, attendance) {
      ctx.commit(SET_EMAIL_ATTENDANCE, attendance)
    },

    async ongoingMailAttendance (ctx, payload) {
      const createdAt = Math.floor(Date.now() / 1000)
      ctx.commit(ONGOING_EMAIL_ATTENDANCE, { ...payload, loading: true, createdAt })
    },

    async setAttendanceSending (ctx, attendanceId) {
      ctx.commit(SENDING_EMAIL_ATTENDANCE, attendanceId)
    },

    async setAttendanceNotSended (ctx, attendanceId) {
      ctx.commit(NOT_SENDED_EMAIL_ATTENDANCE, attendanceId)
    },

    finishSendEmail (ctx, data) {
      ctx.commit(FINISH_SEND_MAIL, data)
    },

    setHistoryKnow (ctx, attendanceId) {
      ctx.commit(SET_HISTORY_KNOW, attendanceId)
    },

    loadBodyMessage (ctx, { attendanceId, messageId }) {
      api.loadBodyMessage(messageId).then(({ body }) => {
        ctx.commit(LOAD_MAIL_BODY_SUCCESS, { attendanceId, messageId, body })
      })
    },

    updateHistoryMail (ctx, attendanceId) {
      ctx.commit(LOAD_MAIL_MESSAGES_START, { attendanceId })

      api.loadEmailMessages(attendanceId).then(({ messages }) => {
        for (const email of messages) {
          if (email.agentStartAt) email.createdAt = email.agentStartAt
          if (email.agentFinishAt) email.createdAt = email.agentFinishAt
          if (email.serverDatetimeAt) email.createdAt = email.serverDatetimeAt
          if (email.sendedAt) email.createdAt = email.sendedAt
          email.directionLabel = email.direction === 'IN' ? 'Mensagem Recebida' : 'Mensagem Enviada'
        }

        ctx.commit(LOAD_MAIL_MESSAGES_SUCCESS, { attendanceId, messages })
      }).catch((err) => {
        console.log({ err })
        ctx.commit(LOAD_MAIL_MESSAGES_ERROR, { attendanceId })
      })
    },

    giveUpEmail (ctx, attendanceId) {
      ctx.commit(GIVEUP_MAIL, attendanceId)
    },

    updateHistoryAttendance (ctx, payload) {
      ctx.commit(UPDATE_ATTENDANCE_HISTORY, payload)
    },

    updateAttendance (ctx, payload) {
      ctx.commit(UPDATE_ATTENDANCE, payload)
    },

    updateAttendanceVoice (ctx, { attendanceId, ...data }) {
      ctx.commit(UPDATE_ATTENDANCE_VOICE, { attendanceId, data })
    },

    async discardAttendanceVoice (ctx, attendanceId) {
      const isRecording = recordings[attendanceId]?.recorder && ctx.state.current[attendanceId]?.isRecording

      if (isRecording) ctx.dispatch('attendanceModule/stopRecord', attendanceId, { root: true })
      ctx.commit(FINISH_ATTENDANCE_VOICE, attendanceId)
    },

    discardConference (ctx) {
      ctx.commit(DISCARD_CONFERENCE)
    },

    addAttendanceConference (ctx, attendanceId) {
      ctx.commit(ADD_ATTENDANCE_CONFERENCE, attendanceId)
    },

    clearHistory ({ commit }) {
      commit(CLEAR_INITIAL_HISTORY)
    },

    setHistory (ctx, attendances) {
      ctx.commit(SET_ATTENDANCE_HISTORY, attendances)
    },

    setProfiler ({ commit }, answers) {
      return commit(SET_PROFILER_ANSWERS, answers)
    },

    async saveProfiler ({ commit, rootState, state, dispatch }, attendanceProfiler) {
      const isEmail = Boolean(attendanceProfiler?.emailMessageIds)
      const attendanceId = isEmail ? attendanceProfiler.attendanceId : attendanceProfiler
      if (!attendanceId) return

      const attendance = state.current[attendanceId] || state.history[attendanceId]
      if (!attendance) return

      let messageId
      let profiler = state.profilers[attendanceId]

      if (isEmail) {
        const { agentEmailMessageId, contactEmailMessageId } = attendanceProfiler.emailMessageIds
        messageId = agentEmailMessageId || contactEmailMessageId
        profiler = state.profilersEmail[attendanceId][messageId]
      }

      if (!profiler) return

      const ura = attendance.sipHeaders || {}

      const { id, mailing, hasHooks, contact, tree, fields, isVoice } = profiler
      const { queue, direction, createdAt: created, queueId, id: callId, channel } = attendance
      const { agent: { id: agent, loginExtension: extension, name: agentName } } = rootState.agentModule.session
      const body = { id, direction, agent, created, contact, agentName, profiler: { fields, tree }, channel }
      if (isVoice) body.callId = callId ?? attendanceId
      if (!isVoice && !isEmail) {
        body.type = 'TEXT'
        body.chatId = attendanceId
        body.contact = getContactNumber(attendance)
      }
      if (isEmail) {
        const { agentEmailMessageId, contactEmailMessageId } = attendanceProfiler.emailMessageIds
        body.type = 'EMAIL'
        body.emailId = attendanceId
        body.agentEmailMessageId = agentEmailMessageId
        body.contactEmailMessageId = contactEmailMessageId
      }

      body.queue = queue || queueId

      body.contactId = ura['X-Dialer-Contact-Id']
      body.contactName = ura['X-Dialer-Contact-Name']

      if (fields?.length) {
        body.fields = fields.map(({ id, type, answer, originalAnswer, configs, scheduleTarget }) => {
          const hasSetOriginalAnswer = Boolean(originalAnswer)
          const shouldSaveOriginalAnwser = isAnonymousField({ options: { configs } })
          if (shouldSaveOriginalAnwser && hasSetOriginalAnswer) answer = originalAnswer
          const field = { id, type, answer }
          if (configs?.scheduleSelection === 'yes' && scheduleTarget) {
            field.isSchedule = true
            field.scheduleTarget = scheduleTarget
            field.scheduledAt = answer
            field.number = contact
            field.queueId = queue || queueId
            field.contactId = ura['X-Dialer-Contact-Id'] || null
            field.contactName = ura['X-Dialer-Contact-Name'] || null
            if (scheduleTarget === 'agent') field.agentId = agent
          }
          return field
        }).filter(noButtonType)
      }
      if (tree?.answers?.length) body.tree = tree.answers

      commit(SET_PROFILER_LOADING, !isEmail ? attendanceId : { attendanceId, messageId })

      let count = 3
      let success = false

      while (!success && count--) {
        await api.postAnswerProfiler(body).then(() => {
          success = true
          commit(SET_PROFILER_EMPTY, !isEmail ? attendanceId : { id: attendanceId, isEmail })
          const newAttendanceProfiler = !isEmail ? attendanceId : { attendanceId, messageId: attendanceProfiler.emailMessageIds }
          dispatch('loadProfiler', newAttendanceProfiler)
          dispatch('setPreviewProfiler', { queueId: queue, attendanceId, hasPerfilated: true })
        }).catch((err) => {
          console.log({ err })
          return new Promise((resolve) => setTimeout(resolve, 800))
        })
      }

      if (!success) return commit(SET_PROFILER_LOADED, attendanceId)
      if (!hasHooks) return

      count = 7
      success = false

      const hookSaveParams = Object.assign(body, { ura, mailing, extension })

      while (!success && count--) {
        await api.execHooks(profiler.id, 'onSave', hookSaveParams).then(() => {
          success = true
        }).catch(() => new Promise((resolve) => setTimeout(resolve, 800)))
      }
    },

    async loadProfiler ({ commit, rootState, state, dispatch }, attendanceProfiler) {
      const isEmail = Boolean(attendanceProfiler?.messageId)
      const attendanceId = isEmail ? attendanceProfiler.attendanceId : attendanceProfiler
      if (!attendanceId) return
      let messageId

      if (isEmail) {
        messageId = hasMessageId(attendanceProfiler)
        commit(SET_PROFILER_LOADING, { attendanceId, messageId })
      }

      const attendance = state.current[attendanceId] || state.history[attendanceId]
      if (!attendance) return
      if (attendance.noProfiler) return

      const contact = String(attendance.contact || '')
      const isListenExtension = contact.includes('*99*')
      if (isListenExtension) return

      const isLoading = Boolean(state.profilers[attendanceId]?.isLoading)
      if (isLoading && !isEmail) return

      const ura = attendance.sipHeaders || {}
      const { channel, status } = attendance
      const isVoice = channel === 'VOICE'

      const isInternalCall = isVoice && contact.length < 7
      const isNotConnectedCall = ['CONNECTING', 'RINGING', 'DISCARDED', 'ABANDONED'].includes(status)
      const isSetProfilerEmpty = (isInternalCall || isNotConnectedCall) && !isEmail
      if (isSetProfilerEmpty) return commit(SET_PROFILER_EMPTY, attendanceId)

      const isLoaded = Boolean(state.profilers[attendanceId]?.id)
      if (isLoaded && !isEmail) return commit(SET_PROFILER_LOADED, attendanceId)

      commit(SET_PROFILER_LOADING, !isEmail ? attendanceId : { attendanceId, messageId })

      const { queue, direction, createdAt: created, queueId, callId } = attendance
      const { agent: { id: agent, loginExtension: extension, name: agentName } } = rootState.agentModule.session
      const body = { direction, agent, created, contact, agentName, channel }
      if (isVoice) body.callId = callId || attendanceId
      if (!isVoice && !isEmail) {
        body.chatId = attendanceId
        body.contact = getContactNumber(attendance)
        if (attendance.protocol) body.protocol = attendance.protocol
      }

      if (isEmail) {
        const { agentEmailMessageId, contactEmailMessageId } = attendanceProfiler.messageId
        body.emailId = attendanceId
        body.agentEmailMessageId = agentEmailMessageId
        body.contactEmailMessageId = contactEmailMessageId
      }

      body.queue = queue || queueId

      if (!body.queue && isEmail) body.queue = state.currentMessageId[attendanceId]?.queueId

      body.contactId = ura['X-Dialer-Contact-Id']
      body.contactName = ura['X-Dialer-Contact-Name']

      if (attendance.flowVariables) body.flowVariables = attendance.flowVariables

      let res = null
      let count = 7

      while (!res && count--) {
        res = await api.getProfiler(Object.assign(body, { ura, extension })).catch(async (err) => {
          const noProfiler = err?.response?.status === 400 && err?.response?.data?.$errors === 'no profiler'
          if (noProfiler) return 'no profiler'
          await new Promise((resolve) => setTimeout(resolve, 1500))
          return null
        })
      }

      if (res === 'no profiler' && !isEmail) return commit(SET_NO_PROFILER, attendanceId)
      if (!res || !res.id) return commit(SET_PROFILER_EMPTY, !isEmail ? attendanceId : { id: attendanceId, isEmail, messageId })

      let { mailing, answer, hasHooks, openUrls, buttonHooks } = res
      if (!Array.isArray(buttonHooks)) buttonHooks = []
      const { id, tree, fields, description } = res
      const isSaved = Number(answer?.agentId || 0) === Number(agent)
      const hasDialerContact = Boolean(ura['X-Dialer-Contact-Id'] && ura['X-Dialer-Contact-Name'])
      const profiler = { id, tree, fields, description, isSaved, attendanceId, isVoice, mailing, hasHooks, contact, isEmail, messageId, hasDialerContact }
      if (isSaved) return commit(SET_PROFILER_SUCCESS, profiler)

      count = 7
      let dataHooks = null
      if (!mailing) mailing = {}

      const endedCall = status === 'COMPLETED'
      if (openUrls.length) {
        for (const openUrl of openUrls) {
          const autoOpen = openUrl.type === 'automatically'

          if (endedCall || !autoOpen) continue
          shell.openExternal(openUrl.url)
        }
      }

      if (hasHooks) {
        while (!dataHooks && count--) {
          dataHooks = await api.execHooks(profiler.id, 'onConnect', Object.assign(body, { ura, mailing, extension, flowVariables: attendance.flowVariables })).catch(async () => {
            await new Promise((resolve) => setTimeout(resolve, 1500))
            return null
          })
        }
      }

      if (!dataHooks) dataHooks = {}

      for (const field of profiler.fields) {
        if (field.answer) continue
        const config = field.options?.configs || {}
        if (isDataURA(config) && config?.dataUra) field.answer = _get(lowerCaseKeys(ura), config.dataUra.toLowerCase())
        if (isDataHook(config) && config?.dataHookPath) field.answer = _get(dataHooks[config.dataHook], config.dataHookPath)
        if (isDataMailing(config) && config?.dataMailing) field.answer = _get(mailing, config.dataMailing)
        if (isDataFlow(config) && config?.dataFlow) field.answer = _get(res.flow, config.dataFlow)
        if (isOpenURL(field, openUrls)) config.url = getUrl(openUrls, config)
        if (isButtonHook(field, buttonHooks)) config.buttonHook = getButtonHook(buttonHooks, config)
        if (isAnonymousField(field)) {
          const anonymizedAnswer = anonymizeText(field.answer)
          field.originalAnswer = field.answer
          field.answer = anonymizedAnswer
        }
      }
      dispatch('setPreviewProfiler', { queueId: body.queue, hasPerfilated: false, attendanceId })
      commit(SET_PROFILER_SUCCESS, profiler)
    },

    async execButtonHook ({ state, rootState, commit }, { attendanceId, profilerId, hookId }) {
      const key = buttonResultKey({ attendanceId, profilerId, hookId })
      commit(SET_BUTTON_RESULT, { key, result: { status: 'running' } })
      try {
        const { display, executedAt } = await execButtonRequest({ state, rootState }, { attendanceId, profilerId, hookId })
        commit(SET_BUTTON_RESULT, { key, result: { status: 'success', display, executedAt } })
      } catch (err) {
        commit(SET_BUTTON_RESULT, { key, result: { status: 'error', errorStatus: err.response?.status || 0 } })
      }
    },

    setChatInputRows ({ commit }, { chatId, rows }) {
      return commit(SET_INPUT_ROWS_TEXT_MESSAGE, { chatId, rows })
    },

    handleLosedAttendances (ctx, chats) {
      ctx.commit(LOSED_ATTENDANCES_TEXT_MESSAGE, chats)
    },

    updateContact (ctx, payload) {
      ctx.commit(UPDATE_CONTACT, payload)
    },

    updateOptionCallback ({ commit }, payload) {
      commit(UPDATE_OPTION_CALLBACK, payload)
    },

    resetOptionCallback ({ commit }) {
      commit(RESET_OPTION_CALLBACK)
    },

    addAttendancetoPreviewSet ({ commit }, id) {
      commit(ADD_ATTENDANCE_TO_PREVIEW_SET, id)
    },

    setPreviewQueueId ({ commit }, id) {
      commit(SET_PREVIEW_QUEUE_ID, id)
    },

    removeAttendanceFromPreview ({ commit }, id) {
      commit(REMOVE_ATTENDANCE_FROM_PREVIEW, id)
    },

    addContactToPreview (ctx, { contact, queueId }) {
      ctx.commit(ADD_CONTACT_TO_PREVIEW, { contact, queueId })
    },
    removeContactFromPreview (ctx, queueId) {
      ctx.commit(REMOVE_CONTACT_FROM_PREVIEW, queueId)
    },

    setPreviewStatus (ctx, { previewStatus, contactStatus, phoneStatus, phone, queueId }) {
      ctx.commit(SET_PREVIEW_STATUS, previewStatus)
      ctx.commit(SET_PREVIEW_CONTACT_STATUS, { queueId, status: contactStatus })
      ctx.commit(SET_PREVIEW_PHONE_STATUS, { queueId, status: phoneStatus, phone })
    },

    setPreviewProfiler (ctx, payload) {
      ctx.commit(SET_PREVIEW_PROFILER, payload)
    }

  },

  mutations: {
    SET_API_ATTENDANCE_DATA: (state, data) => {
      state.apiAttendanceData = data
    },

    CLEAR_API_ATTENDANCE_DATA: (state) => {
      state.apiAttendanceData = null
    },

    START_RECORDING: (state, attendanceId) => {
      if (!state.current[attendanceId]) return
      if (state.current[attendanceId].isRecording) return
      const now = Date.now()
      state.current[attendanceId] = { ...state.current[attendanceId], isRecording: true, startRecordTimestamp: now }
    },

    STOP_RECORDING: onStopRecording,

    [SET_READED]: (state, { chatId, messageId, readedAt, deliveredAt }) => {
      const chat = { ...state.current[chatId] }
      chat.messages = Array.isArray(chat.messages) ? [...chat.messages] : []
      const msg = chat.messages.find(msg => msg.id === messageId)
      if (!msg) return
      if (readedAt) msg.readedAt = readedAt
      if (deliveredAt) msg.deliveredAt = deliveredAt
      state.current = { ...state.current, [chatId]: chat }
    },

    [SET_CHAT_MANUAL_UNREAD]: (state, { chatId, value }) => {
      const normalizedChatId = String(chatId)
      const applyUnreadState = (collection) => {
        const key = Object.keys(collection).find((id) => String(id) === normalizedChatId)
        if (!key) return false

        const chat = collection[key]
        if (!chat || chat.channel !== TEXT_CHANNEL) return false
        if (!value && !chat.manualUnread) return false

        const updatedChat = { ...chat }
        if (value) updatedChat.manualUnread = true
        else delete updatedChat.manualUnread

        collection[key] = updatedChat
        return true
      }

      const current = { ...state.current }
      const updatedCurrent = applyUnreadState(current)
      if (updatedCurrent) {
        state.current = current
        return
      }

      const history = { ...state.history }
      const updatedHistory = applyUnreadState(history)
      if (updatedHistory) {
        state.history = history
      }
    },

    [SET_ATTENDANCE_ATTACHMENT]: (state, { attendanceId, attachment }) => {
      let attendance = { ...state.current[attendanceId] }
      if (state.history[attendanceId]) {
        attendance = { ...state.history[attendanceId] }
        const history = Object.assign({}, state.history)
        delete history[attendanceId]
        state.history = history
        state.current[attendanceId] = attendance
      }

      const attachments = Array.isArray(attendance.attachments) ? [...attendance.attachments] : []
      let index = attachments.findIndex(({ id }) => id === attachment.id)
      if (index === -1) index = attachments.length
      attachments[index] = attachment
      attendance.attachments = attachments
      const current = Object.assign({}, state.current)
      current[attendanceId] = attendance
      state.current = current
    },

    [REMOVE_ATTENDANCE_ATTACHMENT]: (state, { attendanceId, attachment }) => {
      const attendance = { ...state.current[attendanceId] }
      const attachments = Array.isArray(attendance.attachments) ? [...attendance.attachments] : []
      const index = attachments.findIndex(({ id }) => id === attachment.id)
      if (index === -1) return

      attachments.splice(index, 1)
      attendance.attachments = attachments
      state.current[attendanceId] = attendance
    },

    [SET_PROFILER_ANSWERS]: (state, answers) => {
      const { attendanceId } = answers
      const profiler = !answers?.isEmail
        ? state.profilers[attendanceId] ? { ...state.profilers[attendanceId] } : { attendanceId }
        : state.profilersEmail[attendanceId][answers.messageId] ? { ...state.profilersEmail[attendanceId][answers.messageId] } : { messageId: answers.messageId }

      if (answers.tree && answers.tree.length) profiler.tree.answers = answers.tree

      if (answers.fields) {
        profiler.fields.forEach((field) => {
          const fieldData = answers.fields[field.id]
          if ([null, undefined].includes(fieldData)) return
          const answer = fieldData?.answer !== undefined ? fieldData.answer : fieldData
          const scheduleTarget = fieldData?.scheduleTarget
          if (field.answer !== answer) field.answer = answer
          if (scheduleTarget !== undefined) field.scheduleTarget = scheduleTarget
        })
      }
    },

    [SET_PROFILER_LOADING]: (state, attendanceProfiler) => {
      const isEmail = Boolean(attendanceProfiler?.messageId)
      const attendanceId = isEmail ? attendanceProfiler.attendanceId : attendanceProfiler
      clearButtonResults(state, attendanceId)

      if (!isEmail) {
        const profiler = state.profilers[attendanceId] ? { ...state.profilers[attendanceId] } : { attendanceId }
        profiler.isLoading = true
        state.profilers = { ...state.profilers, [attendanceId]: profiler }
      }

      if (isEmail) {
        const { messageId } = attendanceProfiler
        const attendance = state.profilersEmail[attendanceId]
        const profiler = attendance ? { ...attendance[messageId], isLoading: true } : { isLoading: true }
        state.profilersEmail = { ...state.profilersEmail, [attendanceId]: { ...state.profilersEmail[attendanceId], [messageId]: profiler } }
      }
    },

    [SET_PROFILER_LOADED]: (state, attendanceId) => {
      const profiler = { ...state.profilers[attendanceId] }
      profiler.isLoading = false
      state.profilers = { ...state.profilers, [attendanceId]: profiler }
    },

    [SET_PROFILER_SUCCESS]: (state, profiler) => {
      const fields = handleFields(profiler.fields)
      const isEmail = profiler?.isEmail

      if (isEmail) {
        const { attendanceId, messageId, isSaved } = profiler
        state.profilersEmail[attendanceId] = {
          ...state.profilersEmail[attendanceId], [messageId]: { ...profiler, fields, isLoading: false, isSaved }
        }
      }

      if (!isEmail) {
        if (state.current[profiler.attendanceId]) {
          const attendance = { ...state.current[profiler.attendanceId] }
          attendance.isSaved = profiler.isSaved
          state.current[profiler.attendanceId] = attendance
        }

        if (state.history[profiler.attendanceId]) {
          const attendance = { ...state.history[profiler.attendanceId] }
          attendance.isSaved = profiler.isSaved
          state.history[profiler.attendanceId] = attendance
        }

        state.profilers = {
          ...state.profilers,
          [profiler.attendanceId]: { ...profiler, fields, isLoading: false }
        }
      }
    },

    [SET_BUTTON_RESULT]: (state, { key, result }) => {
      state.buttonResults = { ...state.buttonResults, [key]: result }
    },

    [SET_PROFILER_EMPTY]: (state, attendance) => {
      const isEmail = Boolean(attendance?.isEmail)
      const attendanceId = isEmail ? attendance.id : attendance
      clearButtonResults(state, attendanceId)
      if (!isEmail) {
        const profilers = { ...state.profilers }
        delete profilers[attendance]
        state.profilers = profilers
      }

      if (isEmail) {
        const profilersEmail = { ...state.profilersEmail }
        const { id, messageId } = attendance
        delete profilersEmail[id][messageId]
        state.profilersEmail = profilersEmail
      }
    },

    [SET_NO_PROFILER]: (state, attendanceId) => {
      const profilers = { ...state.profilers }
      delete profilers[attendanceId]
      state.profilers = profilers

      if (state.current[attendanceId]) {
        const attendance = { ...state.current[attendanceId] }
        attendance.noProfiler = true
        state.current[attendanceId] = attendance
      }

      if (state.history[attendanceId]) {
        const attendance = { ...state.history[attendanceId] }
        attendance.noProfiler = true
        state.history[attendanceId] = attendance
      }
    },

    [ADD_ATTENDANCE_VOICE]: (state, attendance) => {
      attendance.status = attendance.autoAnswer ? CONNECTED : attendance.status
      attendance.channel = VOICE_CHANNEL
      attendance.createdAt = Date.now()
      if (attendance.autoAnswer) attendance.answerAt = attendance.createdAt

      const callId = attendance?.id
      const oldHistory = Object.values(state.history).find(history => history?.id === callId)
      if (oldHistory?.id) {
        const history = { ...state.history }
        delete history[oldHistory.id]

        state.history = history
      }

      const attendanceId = attendance.id ?? attendance.temporaryId
      state.current = { ...state.current, [attendanceId]: attendance }
    },

    [START_ATTENDANCE_MAIL]: (state, attendance) => {
      const { to, agentId } = attendance
      const createdAt = Math.floor(Date.now() / 1000)
      attendance.direction = 'OUT'
      attendance.status = 'PREPARING'
      attendance.emailMessageId = null
      attendance.createdAt = createdAt
      attendance.channel = MAIL_CHANNEL
      attendance.isNewAttendance = true
      attendance.emailAttendanceId = null
      attendance.temporaryId = uuidv5(`${agentId}|${createdAt}|${to}`, uuidDNS)
      const attendanceId = attendance.id ?? attendance.temporaryId
      state.current = { ...state.current, [attendanceId]: attendance }
    },

    [SET_EMAIL_ATTENDANCE]: (state, email) => {
      const createdAt = Math.floor(Date.now() / 1000)
      const answerAt = createdAt
      const current = Object.assign({}, state.current)
      const history = Object.assign({}, state.history)
      let oldState = Object.assign({}, current[email.emailAttendanceId] || {})

      if (history[email.emailAttendanceId]) {
        oldState = Object.assign({}, history[email.emailAttendanceId])
        delete history[email.emailAttendanceId]
      }

      current[email.emailAttendanceId] = {
        id: `${email.emailAttendanceId}`,
        answerAt,
        createdAt,
        isNewemail: false,
        emailAnswerId: email.emailAnswerId,
        direction: email.direction,
        channel: email.channel,
        temporaryId: email.messageId,
        isOffering: email.isOffering,
        status: email.isOffering ? 'OFFERING' : email.status,

        botId: email.botId,
        agentId: email.agentId,
        queueId: email.queueId,
        queueName: email.queueName,
        emailAttendanceId: email.emailAttendanceId,

        answerOption: oldState.answerOption || 'onlyAnswer',
        subject: oldState?.subject ?? (['OFFERING', 'ANSWERING'].includes(email.status) ? `Re: ${email.mailSubject}` : email.mailSubject),
        message: oldState?.message ?? '<div><br><br>---</div>',
        attachments: oldState?.attachments ?? parseJSON(email.mailAttachments, []),
        messages: oldState?.messages,
        loadStatus: null,

        ...makeMailDestinations(email, oldState)
      }
      state.history = history
      state.current = current
    },

    [LOAD_MAIL_MESSAGES_START]: (state, { attendanceId }) => {
      if (state.current[attendanceId]) state.current[attendanceId] = Object.assign({}, state.current[attendanceId], { loadStatus: 'LOADING', loadedAt: Date.now() })
      if (state.history[attendanceId]) state.history[attendanceId] = Object.assign({}, state.history[attendanceId], { loadStatus: 'LOADING', loadedAt: Date.now() })
    },

    [LOAD_MAIL_BODY_SUCCESS]: (state, { attendanceId, messageId, body }) => {
      let attendance = null
      if (!attendance && state.current[attendanceId]) attendance = Object.assign({}, state.current[attendanceId])
      if (!attendance && state.history[attendanceId]) attendance = Object.assign({}, state.history[attendanceId])
      if (!attendance) return

      const email = attendance.messages.find(({ id }) => id === messageId)
      email.mailBody = body
      const htmlStr = prepareBody(email)

      const serverDate = moment.unix(email.createdAt).format('DD/MM/YY HH:mm')
      const fromContent = email.mailFrom ? email.mailFrom : (email.agentName ? `Agente ${email.agentName} #${email.agentId}` : '')
      const startContent = `<i><b>${email.directionLabel}</b><br>${fromContent ? `De: ${fromContent}<br>` : ''}Data: ${serverDate}<br>Para: ${email.mailTo.map(({ id }) => id).join(', ')}<br>Disse:<br></i>`

      const mailBody = `<div>${startContent}<blockquote>${htmlStr}</blockquote></div>`
      email.mailBody = mailBody

      if (state.current[attendanceId]) state.current[attendanceId] = attendance
      if (state.history[attendanceId]) state.history[attendanceId] = attendance
    },

    [LOAD_MAIL_MESSAGES_SUCCESS]: (state, { attendanceId, messages }) => {
      let attendance = null
      if (!attendance && state.current[attendanceId]) attendance = Object.assign({}, state.current[attendanceId])
      if (!attendance && state.history[attendanceId]) attendance = Object.assign({}, state.history[attendanceId])
      if (!attendance) return

      const oldAttaches = {}

      for (const email of messages) {
        const isOut = email.direction === 'OUT'
        const replyTo = isOut ? email.mailTo : email.replyTo
        const cc = email.mailCc.map(toLabelId)

        let to = replyTo.map(toLabelId)
        if (!to.length) to = [{ id: email.mailFrom, label: email.mailFrom }]

        email.to = to
        email.cc = cc
        email.attachments = email.mailAttachments

        for (const attach of email.mailAttachments) {
          oldAttaches[attach.url] = { ...attach, createdAt: email.createdAt }
        }
      }

      const update = { loadStatus: 'DONE', loadedAt: Date.now() }

      if (messages.length) {
        const oldAttachments = Object.values(oldAttaches).sort((a, b) => b.createdAt - a.createdAt)

        const attendanceMessages = attendance.messages || []
        const mailBodyMap = new Map(attendanceMessages.map(m => [m.id, m.mailBody]))

        messages = messages.map((msg) => {
          if (!msg.mailBody) {
            const mailBody = mailBodyMap.get(msg.id)
            if (mailBody) msg.mailBody = mailBody
          }
          return msg
        })

        update.messages = messages
        update.oldAttachments = oldAttachments
      }

      Object.assign(attendance, update)

      if (messages.length) {
        const isValidOption = attendance.emailParentId && Boolean(messages.find((msg) => msg.id === attendance.emailParentId))
        if (!isValidOption) attendance.emailParentId = null
        if (!attendance.emailParentId) attendance.emailParentId = messages.find((msg) => msg.direction === 'IN')?.id
        if (!attendance.emailParentId) attendance.emailParentId = messages.at(0).id
      }

      if (state.history[attendanceId]) state.history = Object.assign(state.history, { [attendanceId]: attendance })
      if (state.current[attendanceId]) state.current = Object.assign(state.current, { [attendanceId]: attendance })
    },

    [LOAD_MAIL_MESSAGES_ERROR]: (state, { attendanceId }) => {
      if (state.current[attendanceId]) state.current[attendanceId] = Object.assign({}, state.current[attendanceId], { loadStatus: 'ERROR', loadedAt: Date.now() })
      if (state.history[attendanceId]) state.history[attendanceId] = Object.assign({}, state.history[attendanceId], { loadStatus: 'ERROR', loadedAt: Date.now() })
    },

    [ONGOING_EMAIL_ATTENDANCE]: (state, { data }) => {
      const current = Object.assign({}, state.current)
      const history = Object.assign({}, state.history)
      const currentMessageId = Object.assign({}, state.currentMessageId)

      delete history[data.id]
      current[data.id].status = 'ANSWERING'
      current[data.id].botId = data.botId
      current[data.id].queueId = data.queueId
      delete current[data.id].loadStatus
      currentMessageId[data.id] = current[data.id]

      state.history = history
      state.current = current
      state.currentMessageId = currentMessageId
    },

    [SET_HISTORY_KNOW]: (state, attendanceId) => {
      if (!state.current[attendanceId]) return
      const attendance = { ...state.current[attendanceId] }
      attendance.wasUpdated = false
      state.current[attendanceId] = attendance
    },

    [SENDING_EMAIL_ATTENDANCE]: (state, attendanceID) => {
      if (!state.current[attendanceID]) return
      const attendance = { ...state.current[attendanceID] }
      attendance.loading = true
      state.current = { ...state.current, [attendanceID]: attendance }
    },

    [NOT_SENDED_EMAIL_ATTENDANCE]: (state, attendanceID) => {
      if (!state.current[attendanceID]) return
      const attendance = { ...state.current[attendanceID] }
      attendance.loading = false
      state.current = { ...state.current, [attendanceID]: attendance }
    },

    [GIVEUP_MAIL]: (state, attendanceId) => {
      const current = { ...state.current }
      delete current[attendanceId]
      state.current = current
    },

    [FINISH_SEND_MAIL]: (state, data) => {
      const updateFromDash = data.type === 'updateExtension'
      const attendanceId = state.current[data.temporaryId] ? data.temporaryId : data.emailAttendanceId

      const history = Object.assign({}, state.history)
      const current = Object.assign({}, state.current)
      const finishedAttendance = Object.assign({}, current[attendanceId])

      if (finishedAttendance.answerOption === 'onlyGiveBack') {
        delete current[attendanceId]

        state.current = current
        return
      }

      if (updateFromDash) {
        data.status = data.event.match(/(.*?)_MAIL/)[1]
        finishedAttendance.answerOption = ['FINISHED', 'AUTO_CLOSE'].includes(data.status) ? 'onlyFinish' : 'onlyTransfer'
      }

      state.currentMessageId[data.emailAttendanceId] = { id: data.emailMessageId, queueId: data.queueId }
      const isTransfer = data.status === 'TRANSFERRED'
      if (isTransfer) {
        finishedAttendance.status = data.status
        finishedAttendance.answerOption = data.answerOption ?? 'onlyTransfer'
      }

      const { answerOption } = finishedAttendance

      delete finishedAttendance.temporaryId
      delete finishedAttendance.attachments
      delete finishedAttendance.oldAttachments
      delete finishedAttendance.loadStatus
      delete finishedAttendance.messages

      finishedAttendance.id = data.emailAttendanceId
      finishedAttendance.emailAttendanceId = data.emailAttendanceId
      finishedAttendance.status = 'SEND_DONE'
      finishedAttendance.loading = false

      const wasFinished = ['answerFinish', 'onlyFinish'].includes(answerOption)
      const wasTransferred = ['onlyTransfer', 'answerTransfer', 'agentTransfer'].includes(answerOption)

      delete history[attendanceId]
      delete current[attendanceId]

      if (wasFinished || wasTransferred) {
        finishedAttendance.status = wasFinished ? 'FINISHED' : 'TRANSFERRED'
        finishedAttendance.finishedAt = Math.floor(Date.now() / 1000)
        delete finishedAttendance.message
        history[finishedAttendance.id] = finishedAttendance
      } else {
        finishedAttendance.message = '<div><br><br>---</div>'
        history[finishedAttendance.id] = finishedAttendance
      }

      state.current = current
      state.history = history
    },

    [UPDATE_ATTENDANCE]: (state, payload) => {
      const attendanceId = payload.id ?? payload.temporaryId
      const history = { ...state.history }
      const current = { ...state.current }
      if (!attendanceId) return

      let attendance = null
      let isSentOutEmail
      if (!attendance && state.current[attendanceId]) attendance = Object.assign({}, state.current[attendanceId], payload)
      if (!attendance && state.history[attendanceId]) attendance = Object.assign({}, state.history[attendanceId], payload)
      if (!attendance) attendance = Object.assign({}, payload)

      if (attendance && attendance.status === 'OFFERING') return

      const hasMessage = (str) => (
        Boolean(
          String(str || '')
            .replaceAll('<p>', '')
            .replaceAll('</p>', '')
            .replaceAll('<div>', '')
            .replaceAll('</div>', '')
            .replaceAll('<span>', '')
            .replaceAll('</span>', '')
            .replaceAll('---', '')
            .replaceAll('<br>', '')
            .replaceAll('<br />', '')
            .replace(/\n/g, '')
            .replace(/\r/g, '')
            .trim()
        )
      )

      if (attendance.messages?.length) {
        const messages = attendance.messages
        const firstMessage = messages[0]
        isSentOutEmail = firstMessage.direction === 'OUT' || attendance.direction === 'OUT'
      }

      let isOngoing = ['ONGOING', 'ANSWERING', 'PREPARING', 'CONNECTED'].includes(attendance.status)
      const isFinished = ['onlyFinish', 'answerFinish'].includes(attendance.answerOption)
      const sentOutActiveEmail = ['SEND_DONE', 'SENDED'].includes(attendance.status) && isSentOutEmail

      if (hasMessage(attendance.message) && !isOngoing && !isFinished) {
        isOngoing = true
        attendance.answerOption = 'onlyAnswer'
        attendance.status = 'ANSWERING'
      }

      if (isOngoing || sentOutActiveEmail) {
        delete history[attendanceId]
        current[attendanceId] = attendance
        state.current = current
        state.history = history
        return
      }

      const isCurrentlyRecording = state.current[attendanceId]?.isRecording
      if (isCurrentlyRecording) {
        current[attendanceId] = attendance
        state.current = current
        state.history = history
        return
      }

      delete current[attendanceId]
      history[attendanceId] = attendance
      state.current = current
      state.history = history
    },

    [UPDATE_ATTENDANCE_HISTORY]: (state, payload) => {
      const { id } = payload
      if (id) state.history[id] = payload
    },

    [UPDATE_ATTENDANCE_VOICE]: (state, { attendanceId, data }) => {
      const attendances = structuredClone(state.current)
      const setAnswerAt = [CONNECTED, HOLD].includes(data.status) && ![CONNECTED, HOLD].includes(attendances[attendanceId]?.status)
      const answerAt = setAnswerAt ? Date.now() : attendances[attendanceId]?.answerAt ?? null
      attendances[attendanceId] = Object.assign({}, attendances[attendanceId], { answerAt }, data)
      state.current = attendances
    },

    [FINISH_ATTENDANCE_VOICE]: (state, attendanceId) => {
      const history = structuredClone(state.history)
      const current = structuredClone(state.current)
      const conference = Array.isArray(state.conference) ? structuredClone(state.conference) : []
      let attendance = current[attendanceId]
      if (!attendance) attendance = history[attendanceId]

      const status = [CONNECTED, HOLD].includes(attendance.status) ? COMPLETED : DISCARDED

      const conferenceIndex = conference.indexOf(attendanceId)
      if (conferenceIndex > -1) conference.splice(conferenceIndex, 1)

      const rejectedCall = status === DISCARDED && attendance.direction === 'IN'

      if (!rejectedCall) {
        history[attendanceId] = Object.assign({}, attendance, { status, hangupAt: Date.now() })
        delete history[attendanceId].history
      }

      delete current[attendanceId]

      Object.assign(state, { history, current, conference })
    },

    [ADD_ATTENDANCE_CONFERENCE]: (state, attendanceId) => {
      state.conference.push(attendanceId)
    },

    [DISCARD_CONFERENCE]: (state) => {
      state.conference = []
    },

    [CLEAR_INITIAL_HISTORY]: (state) => {
      state.history = []
      state.current = []
      state.preview = {
        attendances: new Set(),
        queueId: null,
        contact: {},
        loading: false,
        status: 'WAITING'
      }
    },

    [SET_ATTENDANCE_HISTORY]: (state, payload) => {
      const chats = Array.isArray(payload.chats) ? payload.chats : []
      const calls = Array.isArray(payload.calls) ? payload.calls : []
      const emails = Array.isArray(payload.emails) ? payload.emails : []

      const current = Object.assign({}, state.current)
      const history = Object.assign({}, state.history)
      const profilers = Object.assign({}, state.profilers)
      const oldCalls = Object.values(history)

      for (const call of calls) {
        let oldHistory = history[call.id] ?? oldCalls.find((item) => item.callId === call.id)
        if (!oldHistory) oldHistory = oldCalls.find((item) => item.id.startsWith('ramal-') && item.contact === call.callerNumber && item.channel === VOICE_CHANNEL)

        if (oldHistory?.id) {
          const profiler = profilers[oldHistory.id] ?? {}
          delete history[oldHistory.id]
          delete profilers[oldHistory.id]
          history[call.id] = { ...oldHistory, ...callToAttendance(call) }
          profilers[call.id] = profiler
        } else {
          history[call.id] = callToAttendance(call)
        }
      }

      for (const chat of chats) {
        if (!history[chat.id]) {
          history[chat.id] = chatToAttendance(chat)
          if (current[chat.id]) delete current[chat.id]
        }
        if (current[chat.id]) {
          delete current[chat.id]
        }
      }

      for (const email of emails) {
        if (email.status === 'ONGOING') {
          if (!current[email.id] && !history[email.id]) {
            current[email.id] = emailToAttendance(email, email.status)
          }
        }

        if (!['ONGOING', 'PENDING', 'OFFERING'].includes(email.status)) {
          if (!history[email.id]) {
            history[email.id] = emailToAttendance(email, email.status)
          }
        }
      }

      state.current = current
      state.history = history
      state.profilers = profilers
    },

    [SET_CALL]: (state, { callId, call }) => {
      state.callDetails = { ...state.callDetails, [callId]: call }
    },

    [SET_ATTENDANCE_TEXT_MESSAGE]: (state, { hasMore, messages, notes, ...chat }) => {
      cancelLosedGrace(chat.id)

      let attendance = null
      if (!attendance && state.current[chat.id]) attendance = { ...state.current[chat.id], ...chat }
      if (!attendance && state.history[chat.id]) attendance = { ...state.history[chat.id], ...chat }
      if (!attendance) attendance = { ...chat }

      attendance.messages = mergeMessages(attendance.messages, messages)
      attendance.notes = mergeAgentNotes(attendance.notes, notes)
      if (hasMore !== undefined) {
        attendance.hasMore = Boolean(hasMore)
        if (messages.length === 0) {
          attendance.hasMore = false
        }
      }

      if (state.history[chat.id]) {
        if (chat.status === 'OFFERING') {
          state.current = { ...state.current, [chat.id]: attendance }
          delete state.history[chat.id]
          return
        }

        state.history = { ...state.history, [chat.id]: attendance }
        return
      }

      state.current = { ...state.current, [chat.id]: attendance }
    },

    [SET_FREQUENCY]: (state, { attendanceId, frequency }) => {
      if (state.current[attendanceId]) state.current[attendanceId] = { ...state.current[attendanceId], frequency }
      if (state.history[attendanceId]) state.history[attendanceId] = { ...state.history[attendanceId], frequency }
    },

    [SET_ATTENDANCES_TEXT_MESSAGE]: (state, chats) => {
      const current = { ...state.current }

      Object.keys(current).forEach((id) => {
        if (current[id].channel === TEXT_CHANNEL) delete current[id]
      })

      for (const chat of chats) {
        if (textSyncState) textSyncState.syncedTextIds.add(normalizeId(chat.id))
        cancelLosedGrace(chat.id)

        chat.messages = chat.messages.slice(0).reverse()
        chat.hasMore = true
        current[chat.id] = chatToAttendance(chat)
      }

      state.current = current
    },

    [CLEAR_ATTENDANCES_TEXT_MESSAGE]: (state) => {
      console.warn('🧹 [CLEAR_ALL_ATTENDANCES] Limpando TODOS os atendimentos de texto', {
        timestamp: new Date().toISOString(),
        attendancesRemovidos: Object.keys(state.current).filter(id => state.current[id].channel === TEXT_CHANNEL),
        stackTrace: new Error().stack
      })

      const current = { ...state.current }

      Object.keys(current).forEach((id) => {
        if (current[id].channel === TEXT_CHANNEL) delete current[id]
      })

      state.current = current
    },

    [ADD_ATTENDANCES_TEXT_MESSAGE]: (state, chats) => {
      const current = { ...state.current }
      const history = { ...state.history }

      for (const chat of chats) {
        if (textSyncState) textSyncState.syncedTextIds.add(normalizeId(chat.id))
        cancelLosedGrace(chat.id)

        if (history[chat.id]) delete history[chat.id]
        chat.messages = chat.messages.slice(0).reverse()
        chat.hasMore = true
        current[chat.id] = chatToAttendance(chat)
      }

      state.history = history
      state.current = current
    },

    [FINISHING_ATTENDANCE_TEXT]: (state, loading) => {
      state.loading = loading
    },

    [FINISH_ATTENDANCE_TEXT]: (state, attendance) => {
      const attendanceId = attendance?.id ?? attendance.temporaryId
      const attendances = state.current
      const history = state.history
      history[attendanceId] = { ...attendances[attendanceId], status: 'FINISHED', finishedAt: Date.now() }
      delete history[attendanceId].history
      state.history = { ...history }
      delete attendances[attendanceId]
      state.current = { ...attendances }
    },

    [DROP_ATTENDANCE_TEXT_MESSAGE]: (state, attendanceId) => {
      const current = { ...state.current }
      delete current[attendanceId]
      state.current = current
    },

    [DROP_SKETCH_TEXT_MESSAGE]: (state, attendanceId) => {
      const current = { ...state.current }
      const history = { ...state.history }
      let email = { ...current[attendanceId] }

      if (!email.id) email = { ...history[attendanceId] }

      email.message = ''
      email.attachments = []
      email.status = 'SEND_DONE'

      delete current[attendanceId]
      history[attendanceId] = email

      state.current = current
      state.history = history
    },

    [SET_AGENT_TEXT]: (state, event) => {
      const { message, chatId, temporaryId, createdAt, type, parentRef, parentMessage } = event
      if (!state.current[chatId]) return
      cancelLosedGrace(chatId)
      const attendance = { ...state.current[chatId] }
      attendance.messages = mergeMessages(attendance.messages, [newAgentMessage(temporaryId, message, chatId, createdAt, type, parentRef, parentMessage)])
      const attendanceId = attendance.id ?? attendance.temporaryId
      state.current = { ...state.current, [attendanceId]: attendance }
    },

    [SET_TEXT_MESSAGE]: (state, event) => {
      if (!state.current[event.chatId]) return
      cancelLosedGrace(event.chatId)
      const { temporaryId, ...msg } = event
      const attendance = { ...state.current[msg.chatId] }
      const messages = Array.isArray(attendance.messages) ? [...attendance.messages] : []
      const oldMsg = messages.find(({ id }) => [temporaryId, msg.id].includes(id))

      msg.createdAt = msg.createdAt * 1000

      if (oldMsg) {
        const index = messages.indexOf(oldMsg)
        messages[index] = Object.assign({}, oldMsg, msg)
      } else {
        messages.push(msg)
      }

      attendance.messages = messages
      const attendanceId = attendance.id ?? attendance.temporaryId
      state.current = Object.assign({}, state.current, { [attendanceId]: attendance })
    },

    [SET_HISTORY_TO_ATTENDANCE]: (state, result) => {
      const { attendanceId, response } = result

      let attendance = null
      if (!attendance && state.current[attendanceId]) attendance = structuredClone(state.current[attendanceId])
      if (!attendance && state.history[attendanceId]) attendance = structuredClone(state.history[attendanceId])
      if (!attendance) return

      if (!attendance.history) attendance.history = []
      attendance.history = toHistory([...attendance.history, ...response.rows])
      attendance.hasMoreHistory = response.count !== 1

      if (state.current[attendanceId]) state.current = Object.assign({}, state.current, { [attendanceId]: attendance })
      if (state.history[attendanceId]) state.history = Object.assign({}, state.history, { [attendanceId]: attendance })
    },

    [SET_INPUT_ROWS_TEXT_MESSAGE]: (state, { chatId, rows }) => {
      state.chatInputRows[chatId] = rows
    },

    [LOSED_ATTENDANCES_TEXT_MESSAGE]: (state, losedAttendances) => {
      for (const attendanceId of losedAttendances) {
        const attendances = state.current
        const history = state.history
        history[attendanceId] = Object.assign({}, attendances[attendanceId], { status: 'LOSED', finishedAt: Date.now() })
        delete history[attendanceId].history
        state.history = structuredClone(history)
        delete attendances[attendanceId]
        state.current = structuredClone(attendances)
      }
    },

    [UPDATE_CONTACT]: (state, { attendance, contact }) => {
      const current = { ...state.current }
      const history = { ...state.history }

      for (const id in current) {
        if (current[id].sourceId === attendance.sourceId && current[id].queueId === attendance.queueId) {
          current[id].contact = contact
        }
      }

      for (const id in history) {
        if (history[id].sourceId === attendance.sourceId && history[id].queueId === attendance.queueId) {
          history[id].contact = contact
        }
      }
    },

    [UPDATE_OPTION_CALLBACK]: (state, callback) => {
      state.optionCallback = { ...state.optionCallback, ...callback }
    },

    [RESET_OPTION_CALLBACK]: (state) => {
      state.optionCallback = {
        timer: 0,
        show: false,
        queue: null,
        contact: null,
        parentCallId: null,
        callbackCallId: null
      }
    },

    [ADD_ATTENDANCE_TO_PREVIEW_SET]: (state, id) => {
      if (state.preview.attendances.size > 0) state.preview.attendances.clear()
      state.preview.attendances.add(id)
    },

    [SET_PREVIEW_QUEUE_ID]: (state, id) => {
      state.preview.queueId = id
    },

    [REMOVE_ATTENDANCE_FROM_PREVIEW]: (state, id) => {
      state.preview.attendances.delete(id)
    },

    [ADD_CONTACT_TO_PREVIEW]: (state, { contact, queueId }) => {
      state.preview.contact[queueId] = contact
    },

    [REMOVE_CONTACT_FROM_PREVIEW]: (state, queueId) => {
      state.preview.contact[queueId] = null
    },

    [SET_PREVIEW_STATUS]: (state, status) => {
      state.preview.status = status
    },

    [SET_PREVIEW_PROFILER] (state, { queueId, hasPerfilated, attendanceId }) {
      if (!state.preview.contact[queueId]) return
      if (!state.preview.attendances.has(attendanceId)) return
      state.preview.contact[queueId].hasPerfilated = hasPerfilated
    },

    [SET_PREVIEW_CONTACT_STATUS]: (state, { queueId, status }) => {
      state.preview.contact[queueId].status = status
    },

    [SET_PREVIEW_PHONE_STATUS]: (state, { queueId, status, phone }) => {
      const phones = state.preview.contact[queueId].phones
      let phoneEntry = phones[phone]

      if (!phoneEntry) {
        phoneEntry = Object.values(phones).find(({ number, formatNumber }) => {
          if (number === phone || formatNumber === phone) return true
          const formatNumberWithoutFirstZero = formatNumber.replace(/^0+/, '')
          return phone === formatNumberWithoutFirstZero
        })
      }

      if (phoneEntry) phoneEntry.status = status
    }

  },

  middlewares: {
    'attendanceModule/ADD_ATTENDANCE_VOICE': (ctx, mutation) => {
      if (!router) router = document.router
      const { id } = mutation.payload
      onShowCallback(ctx, id)
      const activeElement = document.activeElement
      const tagName = String(activeElement?.tagName).toUpperCase()
      const classList = activeElement?.classList
      const dialingInPreview = ctx.state.attendanceModule?.preview?.status === 'DIALING'
      const redirectToPreview = router.currentRoute.name === ROUTE_PREVIEW_DETAILS && dialingInPreview
      const manualAttendance = mutation.payload.direction === 'OUT'

      if (redirectToPreview && manualAttendance) {
        ctx.dispatch('attendanceModule/addAttendancetoPreviewSet', id)
        router.push({ name: ROUTE_PREVIEW_CURRENT, params: { attendanceId: id, queueId: router.currentRoute.params.queueId } }).catch(() => null)
        return
      }

      const canRedirect = router.currentRoute.name === 'ROUTE_ATTENDANCE_NEW' || !(['INPUT', 'TEXTAREA'].includes(tagName) || classList?.contains('ck-content'))

      if (canRedirect) router.push({ name: ROUTE_ATTENDANCE_ITEM, params: { attendanceId: id } }).catch(() => null)
    },

    'agentModule/SET_SESSION': (ctx, { payload }) => {
      const { agent } = payload
      ctx.dispatch('attendanceModule/setHistory', agent, { root: true })
    },

    [`attendanceModule/${SET_READED}`]: (ctx) => calcPendingMessages(ctx),
    [`attendanceModule/${SET_TEXT_MESSAGE}`]: (ctx) => calcPendingMessages(ctx),
    [`attendanceModule/${SET_ATTENDANCE_TEXT_MESSAGE}`]: (ctx) => calcPendingMessages(ctx),
    [`attendanceModule/${ADD_ATTENDANCES_TEXT_MESSAGE}`]: (ctx) => calcPendingMessages(ctx),
    [`attendanceModule/${SET_ATTENDANCES_TEXT_MESSAGE}`]: (ctx) => calcPendingMessages(ctx),
    [`attendanceModule/${DROP_ATTENDANCE_TEXT_MESSAGE}`]: (ctx, { payload }) => {
      calcPendingMessages(ctx)
      onFinishAttendance(ctx, payload)
    },
    [`attendanceModule/${CLEAR_ATTENDANCES_TEXT_MESSAGE}`]: (ctx) => calcPendingMessages(ctx),
    [`attendanceModule/${FINISH_ATTENDANCE_TEXT}`]: (ctx) => calcPendingMessages(ctx),
    [`attendanceModule/${LOSED_ATTENDANCES_TEXT_MESSAGE}`]: (ctx, { payload }) => {
      calcPendingMessages(ctx)

      const attendanceIds = Array.isArray(payload) ? payload : [payload]
      for (const attendanceId of attendanceIds) {
        onFinishAttendance(ctx, attendanceId)
      }
    },

    'attendanceModule/START_ATTENDANCE_MAIL': (_, { payload }) => {
      const { temporaryId } = payload
      router.push({ name: ROUTE_ATTENDANCE_ITEM, params: { attendanceId: temporaryId } }).catch(() => null)
    },

    'attendanceModule/FINISH_SEND_MAIL': (ctx, { payload }) => {
      const attendanceId = typeof payload === 'object' ? payload.emailAttendanceId || payload.id : payload
      onFinishAttendance(ctx, attendanceId)

      if (payload.emailAttendanceId) {
        ctx.dispatch('attendanceModule/updateHistoryMail', payload.emailAttendanceId, { root: true })
      }
    },

    'attendanceModule/ONGOING_EMAIL_ATTENDANCE': (ctx, { payload }) => {
      if (payload.data?.id) {
        ctx.dispatch('attendanceModule/updateHistoryMail', payload.data.id, { root: true })
      }
    },

    'attendanceModule/SET_EMAIL_ATTENDANCE': (ctx, { payload }) => {
      if (payload.emailAttendanceId) {
        ctx.dispatch('attendanceModule/updateHistoryMail', payload.emailAttendanceId, { root: true })
      }
    },

    'attendanceModule/FINISH_ATTENDANCE_TEXT': (ctx, { payload }) => {
      onFinishAttendance(ctx, payload)
      calcPendingMessages(ctx)
    },

    'attendanceModule/FINISH_ATTENDANCE_VOICE': (ctx, { payload }) => {
      onShowCallback(ctx, payload)
      onFinishAttendance(ctx, payload)
      calcPendingMessages(ctx)
      managePreviewOnFinish(ctx, payload)
    },

    'attendanceModule/STOP_RECORDING': async (ctx, { payload }) => {
      const attendanceId = payload

      await Helpers.wait(500)
      const attendance = ctx.state.attendanceModule.current[attendanceId] || ctx.state.attendanceModule.history[attendanceId]
      const sendToS3 = attendance && attendance.recordBlob && attendance.recordBlob.size > 0

      if (sendToS3) ctx.dispatch('attendanceModule/uploadRecordingToS3', attendanceId, { root: true })
    },

    'attendanceModule/UPDATE_ATTENDANCE_VOICE': (ctx, { payload }) => {
      const attendanceId = payload.attendanceId
      const attendances = ctx.state.attendanceModule?.preview?.attendances
      const isPreviewAttendance = attendances instanceof Set && attendances.has(attendanceId)
      const callId = payload?.data?.callId
      const addPreviewAttendance = isPreviewAttendance && callId
      if (addPreviewAttendance) postPreviewAttendance(ctx, attendanceId, 'DIALED')
      if (payload.data?.status === CONNECTED && payload.data?.answerAt) {
        onShowCallback(ctx, attendanceId)
      }
    },

    'attendanceModule/UPDATE_OPTION_CALLBACK': (ctx, { payload }) => {
      if (payload.callbackCallId && !String(payload.callbackCallId).startsWith('ramal-')) {
        const optionCallback = ctx.state.attendanceModule.optionCallback
        api.postCallbackCalls(optionCallback)
        ctx.dispatch('attendanceModule/resetOptionCallback', {}, { root: true })
      }
    }
  }
}

const handleFields = (profilerFields) => {
  let fields = Array.isArray(profilerFields) ? profilerFields : []

  for (const field of fields) {
    field.configs = field?.options?.configs ?? {}
    field.configs.values = Array.isArray(field?.options?.values) ? field.options.values : []
    if ([null, undefined, ''].includes(field.configs.ordination)) field.configs.ordination = fields.length + field.id
    delete field.options
  }

  fields.sort(({ configs: a }, { configs: b }) => a.ordination - b.ordination)
  fields = fields.filter(canShowField)

  return fields
}

const toContact = (contact) => {
  if (!contact) contact = String(contact).trim()
  if (isLid(contact)) return contact
  if (contact.startsWith('0')) contact = contact.substr(1)
  return contact.startsWith('55') && contact.length > 10 ? contact.substr(2) : contact
}
const toHistory = (attendances) => {
  let lastReceived

  return attendances.reverse().map((row) => {
    const isIn = row.direction === 'IN'
    if (!isIn) return row

    const incidenceType = lastReceived ? getIncidenceType(row, lastReceived) : ''
    lastReceived = row.createdAt
    return { ...row, incidenceType }
  }).reverse()
}

const getIncidenceType = ({ createdAt }, lastReceived) => {
  const last24Hours = 24 * 3600
  const lastMonth = last24Hours * 30
  const last90Days = lastMonth * 3

  if (createdAt - lastReceived <= last24Hours) return 'Rechamada'
  if (createdAt - lastReceived <= lastMonth) return 'Reincidente'
  if (createdAt - lastReceived <= last90Days) return 'Recorrente'
}

const lowerCaseKeys = (obj) => (
  Object.keys(obj).reduce((acc, key) => {
    acc[key.toLowerCase()] = obj[key]
    return acc
  }, {})
)

const byVoice = ({ channel, status }) => channel === VOICE_CHANNEL || status !== 'ONGOING'
const noButtonType = ({ type }) => type !== 'BUTTON'
const canShowField = ({ configs, type }) => noButtonType({ type }) || configs?.url || configs?.buttonHook

const calcPendingMessages = (ctx) => {
  const { attendanceModule } = ctx.state
  const chats = Object.values(attendanceModule.current).filter(({ channel, messages }) => channel === 'TEXT' && Boolean(messages?.length))
  const unreadsCount = chats.reduce((acc, { messages }) => acc + messages.filter((msg) => msg.direction === 'IN' && !msg.readedAt && msg.type !== 'REACTION').length, 0)
  ipcRenderer.send('update-overlay-icon', renderOverlayIcon(unreadsCount), unreadsCount)
}

const onShowCallback = async (ctx, attendanceId) => {
  const { history, current, optionCallback } = ctx.state.attendanceModule
  const attendance = current[attendanceId] || history[attendanceId]
  if (!attendance) return

  const { queue, direction, contact, status } = attendance
  const contactCallback = optionCallback.contact

  if (direction === 'OUT' && contactCallback === contact) {
    return ctx.dispatch('attendanceModule/updateOptionCallback', { callbackCallId: attendanceId }, { root: true })
  }

  if (direction === 'IN' && !optionCallback.callTransferred) {
    ctx.dispatch('attendanceModule/resetOptionCallback', {}, { root: true })

    if (status === CONNECTED) await ctx.dispatch('agentModule/getQueuesProperties', queue, { root: true })
    if (status !== COMPLETED) return

    const queueProps = ctx.state.agentModule.queuesProperties[queue] || {}
    const { wrapUpTime, showOptionCallback } = queueProps

    if (showOptionCallback !== 'yes') return

    ctx.dispatch('attendanceModule/updateOptionCallback', { show: true }, { root: true })

    const areaCode = ctx.state.agentModule?.provision?.areaCode || ''
    const { contact: contactDestination } = await getFormatedNumber({ contact }, areaCode)

    return ctx.dispatch('attendanceModule/updateOptionCallback', { show: true, parentCallId: attendanceId, contact: contactDestination, queue, timer: Number(wrapUpTime) }, { root: true })
  }

  ctx.dispatch('attendanceModule/resetOptionCallback', {}, { root: true })
}

const onFinishAttendance = (ctx, attendanceId) => {
  const { agentModule, attendanceModule } = ctx.state
  const agent = agentModule.session?.agent
  const attendances = Object.values(attendanceModule.current).filter(byVoice)
  const isOnlineAgent = [ONLINE, PAUSED, DIALING, ONTHEPHONE, RINGING].includes(agent?.status)

  const canGoToAuth = !attendances.length && !isOnlineAgent

  if (canGoToAuth) {
    ctx.dispatch('socketModule/finish', null, { root: true })
    return router.push({ name: ROUTE_AUTH }).catch(() => null)
  }

  const currentRoute = router.currentRoute
  const isRouteAttendanceFinished = currentRoute.name === ROUTE_ATTENDANCE_ITEM && String(currentRoute.params.attendanceId) === String(attendanceId)
  if (isRouteAttendanceFinished) goToNextAttendance(attendances)
  if (!isOnlineAgent) return false

  const holdingSchedulePause = Object.values(attendanceModule.current).filter(countsForSchedulePause(agentModule.session.schedulePause))
  const canApplySchedulePause = Boolean(!holdingSchedulePause.length && agentModule.session.schedulePause && !attendanceModule.optionCallback.show)
  if (canApplySchedulePause) ctx.dispatch('sipModule/pause', agentModule.session.schedulePause, { root: true })

  const canApplyScheduleLogout = Boolean(!attendances.length && agentModule.session.scheduleLogout && !attendanceModule.optionCallback.show)
  if (canApplyScheduleLogout) ctx.dispatch('sipModule/logout', null, { root: true })
}

const goToNextAttendance = (attendances) => {
  const targetRoute = attendances.length ? ROUTE_ATTENDANCE_ITEM : ROUTE_ATTENDANCE_NEW
  let routeParams = { name: targetRoute }

  if (attendances.length) {
    const attendanceId = attendances[0].id || attendances[0].temporaryId
    routeParams = Object.assign(routeParams, { path: `${targetRoute}/${attendanceId}`, params: { attendanceId, isHistory: false } })
  }

  router.push(routeParams).catch(() => null)
}

const mergeMessages = (oldMessages, newMessages) => {
  const messages = Array.isArray(oldMessages) ? [...oldMessages] : []
  const incMessages = Array.isArray(newMessages) ? [...newMessages] : []

  for (const incMessage of incMessages) {
    const index = messages.findIndex(({ id }) => id === incMessage.id)

    if (index !== -1) {
      messages.splice(index, 1, incMessage)
      continue
    }

    messages.push(incMessage)
  }

  return messages.sort((a, b) => {
    const aIsUUID = isNaN(Number(a.id))
    const bIsUUID = isNaN(Number(b.id))

    if (!aIsUUID && !bIsUUID) {
      return Number(a.id) - Number(b.id)
    }

    if (aIsUUID && bIsUUID) {
      return new Date(a.createdAt) - new Date(b.createdAt)
    }

    return aIsUUID ? 1 : -1
  })
}

const newAgentMessage = (id, message, chatId, createdAt, type, parentRef, parentMessage) => ({
  id,
  type,
  message,
  chatId,
  createdAt,
  direction: 'OUT',
  parentRef,
  parentMessage,
  readedAt: null,
  answeredAt: null,
  deliveredAt: null,
  ref: null
})

const callToAttendance = (call) => ({
  ...call,
  channel: VOICE_CHANNEL,
  contact: call.callerNumber,
  queue: call.queueId,
  answerAt: call.answerAt ? call.answerAt * 1000 : null,
  createdAt: call.createdAt ? call.createdAt * 1000 : null,
  hangupAt: call.hangupAt ? call.hangupAt * 1000 : null
})

const chatToAttendance = (chat) => {
  const messages = toMessages(chat.messages ?? [])
  const attendance = {
    ...chat,
    hasMore: true,
    loadedAsEmpty: !messages.length,
    channel: TEXT_CHANNEL,
    contact: getContactNameChat(chat),
    queue: chat.queueId,
    createdAt: (chat.createdAt || chat.created_at) ? (chat.createdAt || chat.created_at) * 1000 : null,
    answeredAt: (chat.answeredAt || chat.answered_at) ? (chat.answeredAt || chat.answered_at) * 1000 : null,
    finishedAt: (chat.finishedAt || chat.finished_at) ? (chat.finishedAt || chat.finished_at) * 1000 : null,
    lastMessageAt: (chat.lastMessageAt || chat.last_message_at) ? (chat.lastMessageAt || chat.last_message_at) * 1000 : null,
    messages,
    notes: toAgentNotes(chat.notes)
  }

  if (chat.unread) attendance.manualUnread = true

  return attendance
}

const toMessages = (messages) => (
  messages.map((message) => ({
    ...message,
    createdAt: message.createdAt ? message.createdAt * 1000 : null,
    deliveredAt: message.deliveredAt ? message.deliveredAt * 1000 : null,
    readedAt: message.readedAt ? message.readedAt * 1000 : null,
    answeredAt: message.answeredAt ? message.answeredAt * 1000 : null,
    lastResponse: message.createdAt ? message.createdAt * 1000 : null
  }))
)

const emailToAttendance = (attendance, status = 'FINISHED', oldState = {}) => ({
  status,
  oldAttachments: [],

  id: attendance.id,

  from: attendance.mailFrom,
  createdAt: attendance.serverDatetimeAt,
  emailParentId: attendance.emailMessageId,

  channel: MAIL_CHANNEL,
  direction: attendance.direction || oldState.direction,
  isOffering: false,
  isNewAttendance: false,

  botId: attendance.botId,
  agentId: attendance.latestAgentId,
  queueId: attendance.queueId,
  queueName: attendance.queueName,
  emailAttendanceId: attendance.id,

  answerOption: oldState.answerOption || 'onlyAnswer',
  subject: oldState?.subject ?? (status === 'ANSWERING' ? `Re: ${attendance.mailSubject}` : attendance.mailSubject),
  message: oldState?.message ?? '',
  attachments: oldState?.attachments ?? [],

  ...makeMailDestinations(attendance, oldState)
})

const makeMailDestinations = (data, oldData) => {
  const mapTO = {}
  const mapCC = {}
  const mailCc = typeof data.mailCc === 'string' ? parseJSON(data.mailCc, []) : (Array.isArray(data.mailCc) ? data.mailCc : [])
  const mailTo = typeof data.mailTo === 'string' ? parseJSON(data.mailTo, []) : (Array.isArray(data.mailTo) ? data.mailTo : [])
  const replyTo = typeof data.replyTo === 'string' ? parseJSON(data.replyTo, []) : (Array.isArray(data.replyTo) ? data.replyTo : [])

  if (Array.isArray(oldData.cc)) {
    for (const cc of oldData.cc) {
      mapCC[cc.id] = cc
    }
  }

  for (const cc of mailCc) {
    mapCC[cc.id] = cc
  }

  if (Array.isArray(oldData.to)) {
    for (const to of oldData.to) {
      mapTO[to.id] = to
      delete mapCC[to.id]
    }
  }

  for (const to of replyTo) {
    mapTO[to.id] = to
    delete mapCC[to.id]
  }

  for (const to of mailTo) {
    mapTO[to.id] = to
    delete mapCC[to.id]
  }

  return {
    cc: Object.values(mapCC).map(({ id }) => ({ id, label: id })),
    to: Object.values(mapTO).map(({ id }) => ({ id, label: id }))
  }
}

const getContactNameChat = (chat) => {
  if (chat.name) return chat.name

  const contactInfo = parseContactInfo(chat.info)
  if (!contactInfo) return 'Cliente'

  return contactDisplayName(contactInfo) ?? 'Desconhecido'
}

const findProfilerById = (state, attendanceId, profilerId) => {
  const profiler = state.profilers[attendanceId]
  if (profiler?.id === profilerId) return profiler

  const emailProfilers = state.profilersEmail[attendanceId] || {}
  return Object.values(emailProfilers).find((emailProfiler) => emailProfiler.id === profilerId)
}

const isDataHook = (config) => config.dataOrigin === 'hook'
const isDataURA = (config) => config.dataOrigin === 'header'
const isDataMailing = (config) => config.dataOrigin === 'mailing'
const isDataFlow = (config) => config.dataOrigin === 'flow'
const toLabelId = ({ id, label }) => ({ id, label: label || id })
const isOpenURL = ({ type, options }, openUrls) => openUrls.find(({ id }) => id === options.configs.dataHook && type === 'BUTTON')
const isButtonHook = ({ type, options }, buttonHooks) => buttonHooks.find(({ id }) => id === options.configs.dataHook && type === 'BUTTON')
const isAnonymousField = ({ options }) => options.configs.fieldAnonymous === 'yes'

export const parseJSON = (str, defaultValue) => {
  try {
    return str ? JSON.parse(str) : defaultValue
  } catch (error) {
    return defaultValue
  }
}

const getUrl = (openUrls, { dataHook }) => {
  const { url } = openUrls.find(({ id }) => id === dataHook)
  return url
}

const getButtonHook = (buttonHooks, { dataHook }) => {
  const { id, action, successFields, confirmBeforeRun, variables } = buttonHooks.find(({ id }) => id === dataHook)
  return { id, action, successFields, confirmBeforeRun, variables: Array.isArray(variables) ? variables : [] }
}

export const prepareBody = (email) => {
  if (!Array.isArray(email.mailBody)) return email.mailBody ?? ''

  const textHtml = email.mailBody.find((item) => String(item['Content-Type'] || '').includes('text/html'))

  if (textHtml) {
    const htmlDOM = parse(textHtml?.body || '<div></div>')
    return htmlDOM.querySelector('body')?.innerHTML ?? htmlDOM?.innerHTML ?? '<div></div>'
  }

  const textPlain = email.mailBody.find((item) => String(item['Content-Type'] || '').includes('text/plain'))
  let tmpBody = textPlain.body.replace(/\r\n/g, '\n<br>').replace(/\r/g, '\n<br>').replace(/\n/g, '\n<br>')
  while (tmpBody.includes('\n<br><br>')) tmpBody = tmpBody.replace('\n<br><br>', '\n<br>')

  return tmpBody
}

const renderOverlayIcon = (unreadsCount) => {
  const canvas = document.createElement('canvas')
  canvas.height = 128
  canvas.width = 128
  canvas.style.letterSpacing = '-5px'

  const ctx = canvas.getContext('2d')
  ctx.fillStyle = '#f42020'
  ctx.beginPath()
  ctx.ellipse(64, 64, 64, 64, 0, 0, 2 * Math.PI)
  ctx.fill()
  ctx.textAlign = 'center'
  ctx.fillStyle = 'white'
  ctx.font = '90px sans-serif'
  ctx.fillText(Math.min(99, unreadsCount).toString(), 64, 96)

  return canvas.toDataURL()
}

const hasMessageId = (attendanceProfiler) => {
  if (Number(attendanceProfiler)) return null
  const { agentEmailMessageId, contactEmailMessageId } = attendanceProfiler.messageId
  return agentEmailMessageId || contactEmailMessageId
}

const managePreviewOnFinish = (ctx, id) => {
  const attendances = ctx.state.attendanceModule.preview.attendances
  const ongoingCallIsPreview = attendances instanceof Set && attendances.has(id)
  if (!ongoingCallIsPreview) return

  const { attStatus, queueId, contactPhone } = postPreviewAttendance(ctx, id)
  ctx.dispatch('attendanceModule/setPreviewStatus', { previewStatus: 'WAITING', contactStatus: 'WAITING', phoneStatus: attStatus, phone: contactPhone, queueId }, { root: true })

  const attProfiler = ctx.state.attendanceModule.profilers[id]

  if (attProfiler?.id) return

  ctx.dispatch('attendanceModule/removeAttendanceFromPreview', id, { root: true })
  routeToPreviewDetails(queueId)
}

const postPreviewAttendance = (ctx, id, postStatus = null) => {
  const attendance = ctx.state.attendanceModule.current[id] ?? ctx.state.attendanceModule.history[id]
  const callId = attendance.callId || attendance.id
  const attStatus = postStatus ?? attendance?.status
  const queueId = attendance.queue

  let areaCode = ctx.rootState?.settingsModule?.provision?.areaCode
  if (!areaCode) areaCode = ctx.rootState?.agentModule?.provision?.areaCode || ''
  const contactPhone = getAttendanceNumber(attendance, areaCode)
  const previewContact = ctx.state.attendanceModule.preview.contact[queueId]
  const phones = previewContact.phones
  let phoneId = phones[contactPhone]?.id
  if (!phoneId) phoneId = Object.values(phones).find(({ number, formatNumber }) => number === contactPhone || formatNumber === contactPhone)?.id

  api.postPreviewAttendances({ contactId: previewContact.id, phoneId, callId, attendanceStatus: attStatus })
  return { callId, attStatus, queueId, contactPhone }
}

const routeToPreviewDetails = (queueId) => router.push({ name: ROUTE_PREVIEW_DETAILS, params: { queueId } }).catch(() => null)

const anonymizeText = (text) => {
  const MASK = '*******'
  if (typeof text !== 'string') return text

  const words = text.trim().split(/\s+/)

  if (words.length === 0) return null
  if (words.length <= 2) return words.map(() => MASK).join(' ')

  const firstWord = words[0]
  const lastWord = words[words.length - 1]
  const middleMasked = Array(words.length - 2).fill(MASK).join(' ')

  return `${firstWord} ${middleMasked} ${lastWord}`
}
